import * as Yup from "yup";

export const schemaAccountSettings = Yup.object().shape({
  firstName: Yup.string()
    .min(3, "First name must be at least 3 characters long")
    .required("First name is a required field"),
  lastName: Yup.string()
    .min(3, "Last name must be at least 3 characters long")
    .required("Last name is a required field"),
  entityName: Yup.string()
    .min(3, "Entity name must be at least 3 characters long")
    .required("Entity name is a required field"),
  email: Yup.string()
    .email("Field email is wrong")
    .required("Email is a required field"),
});
